<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card v-if="!this.secret">
      <HeaderDividerBlock headerText="Update New User"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Employee Number*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.employee_no"
              required
              placeholder="Enter Employee Number*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">First Name*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.first_name"
              required
              placeholder="Enter First Name*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Last Name*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.last_name"
              required
              placeholder="Enter Last Name*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Email*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.email"
              required
              placeholder="Enter Email*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Role*</p>
            </v-col>
            <v-select
              v-model="form.role_name"
              :items="role_names"
              :item-text="'name'"
              :item-value="'name'"
              placeholder="Select Role*"
              dense
              outlined
              multiple
            ></v-select>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Cost Per Hour*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.cph"
              required
              :placeholder="`Cost Per Hour* (${currencyCode})`"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Mobile*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.mobile"
              required
              placeholder="Enter Mobile*"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Phone</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.phone"
              required
              placeholder="Enter Phone"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Address 01*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.address01"
              placeholder="Enter Address 01*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Address 02</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.address02"
              placeholder="Enter Address 02"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Country*</p>
            </v-col>
            <v-autocomplete
              v-model="form.country_id"
              :items="countries"
              placeholder="Select Country*"
              item-text="country_name"
              item-value="id"
              dense
              outlined
              clearable
              @change="onCountryChange"
            ></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">State*</p>
            </v-col>
            <v-autocomplete
              v-model="form.state_id"
              :items="states"
              placeholder="Select State*"
              item-text="name"
              item-value="id"
              dense
              outlined
              clearable
            ></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">City*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.city"
              placeholder="Enter City*"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Branch*</p>
            </v-col>
            <v-autocomplete
              v-model="form.branch_id"
              :items="branches"
              placeholder="Select Branch*"
              item-text="name"
              item-value="id"
              dense
              outlined
              clearable
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              v-if="hasPermission('user.edit')"
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="update()"
              >Update</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { EmployerService } from "@/services/employer-service.js";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "EditEmployer",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: ["name"],
  data: () => ({
    form: {
      employee_no: "",
      first_name: "",
      last_name: "",
      email: "",
      status: "",
      address01: "",
      address02: "",
      country_id: "",
      city: "",
      state_id: "",
      cph: "",
      phone: "",
      mobile: "",
      branch_id: "",
      country: "",
    },

    countries: [],
    states: [],
    snackbar: false,
    QR: "",
    secret: null,
    employee_data: "",
    snackbarError: false,
    successMsg: "Employer has been created successfully",
    errors: null,
    loading: false,
    role_names: [],
    specialities: [],
    branches: [],
    phoneRules: [
      (v) =>
        !v || /^\d{10}$/.test(v) || "Phone number must be exactly 10 digits",
    ],
  }),

  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
    }),
  },

  async created() {
    await this.getRolesList();
    this.getBranches();
    this.getCountries();
    await this.getEmployeeInfo();
  },

  methods: {
    async getEmployeeInfo() {
      this.loading = true;
      await this.getRolesList();
      EmployerService.getEmployerInfoByUuid(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            const EmployerData = response.data.data;
            this.setDefaultFormValues(EmployerData);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onCountryChange(countryId) {
      if (countryId) {
        this.getStates(countryId);
      } else {
        this.states = [];
      }
    },
    update() {
      this.loading = true;
      this.errors = null;
      let fd = new FormData();

      fd.append("employee_no", this.form.employee_no);
      fd.append("first_name", this.form.first_name);
      fd.append("last_name", this.form.last_name);
      fd.append("email", this.form.email);
      fd.append("address01", this.form.address01 || "");
      fd.append("address02", this.form.address02 || "");
      fd.append("city", this.form.city || "");
      fd.append("state_id", this.form.state_id || "");
      const roleValue = Array.isArray(this.form.role_name)
        ? this.form.role_name.join(",")
        : (this.form.role_name || "");
      fd.append("role_name", roleValue);
      fd.append("cost_per_hour", this.form.cph || "");
      fd.append("phone", this.form.phone || "");
      fd.append("mobile", this.form.mobile || "");
      fd.append("branch_id", this.form.branch_id || "");
      fd.append("country_id", this.form.country_id || "");

      EmployerService.updateEmployer1(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/employers");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    getRolesList() {
      return new Promise((resolve) => {
        EmployerService.getRolesList()
          .then((response) => {
            if (response.data) {
              this.role_names = Array.isArray(response.data) ? response.data : [];
            }
            resolve();
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            resolve();
          });
      });
    },

    async setDefaultFormValues(EmployerData) {
      this.form = {
        ...this.form,
        employee_no: EmployerData.employee_no || "",
        first_name: EmployerData.first_name || "",
        last_name: EmployerData.last_name || "",
        email: EmployerData.email || "",
        address01: EmployerData.address01 || "",
        address02: EmployerData.address02 || "",

        city: EmployerData.city || "",
        state_id: "",
        role_name: (EmployerData.roles || []).map(r => r.name),
        cph: EmployerData.cost_per_hour || "",
        phone: EmployerData.phone || "",
        mobile: EmployerData.mobile || "",
        branch_id: EmployerData.branch || "",
        country_id: EmployerData.country || "",
      };
      if (EmployerData.country) {
        await this.getStates(EmployerData.country);
        this.form.state_id = EmployerData.state || "";
      }
    },

    getBranches() {
      this.loading = true;
      CommonService.getBranches()
        .then((response) => {
          this.loading = false;

          if (response.data) {
            this.branches = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    async getCountries() {
      this.loading = true;
      try {
        const countries = await EmployerService.getCountries();
        this.countries = countries.data.data;
      } catch (err) {
        console.error(err);
        this.errors = err.response?.data || "Error fetching Countries.";
      }
    },
    async getStates(countryId) {
      this.loading = true;
      try {
        const response = await EmployerService.getStates(countryId);
        this.states = response.data;
      } catch (err) {
        console.error(err);
        this.errors = err.response?.data || "Error fetching States.";
      } finally {
        this.loading = false;
      }
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
  },
};
</script>
